import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
    partner_image: {
        width: '100%',
        '& img': {
            display: 'block',
            width: '100%',
        },
    },
});
export default useStyles;
